import classNames from "classnames";
import { useDevice } from "contexts/deviceContext";
import { Routes } from "generated/routes";
import Link from "next/link";
import React from "react";
import { interviewValidYear } from "common";
import { useCurrentEntor } from "contexts/appContext";
import { InterviewStatus } from "generated/graphql";

import interviewOnlineImage from "../../../../assets/images/interview-online.svg";
import { Button } from "../button";
import { RecommendedBox } from "../recommendedBox";
import styles from "./index.module.scss";
interface Props {
  className?: string;
}

const InterviewBanner: React.FC<Props> = ({ className }) => {
  const device = useDevice();
  const isMobile = device === "mobile";
  const currentEntor = useCurrentEntor();

  const subTitle = (
    <div className={styles.subtitle}>
      {!currentEntor ? (
        "各業界の優秀なメンターが、あなたの就活を徹底サポートします。ZoomやLINEなどいつでもどこでも気軽に就活相談できる。"
      ) : currentEntor?.interviewStatus === InterviewStatus.Applied ? (
        <span>
          {currentEntor.user.lastGraduationYear}
          年卒として面談に申し込み済みです。卒年度を変更したい場合は
          <Link href={Routes.url("/mypage/info/edit", {})}>
            <a className={styles.link}>こちらから変更</a>
          </Link>
          ができます。
        </span>
      ) : interviewValidYear(currentEntor?.user.lastGraduationYear || 0) ? (
        <span>
          {currentEntor?.user.lastGraduationYear}
          年卒として面談申し込みが可能です。 卒年度を変更したい場合は
          <Link href={Routes.url("/mypage/info/edit", {})}>
            <a className={styles.link}>こちらから変更</a>
          </Link>
          ができます。
        </span>
      ) : (
        <span>
          本アカウントはメンターサービスの対象年次外です。卒年度を変更したい場合は
          <Link href={Routes.url("/mypage/info/edit", {})}>
            <a className={styles.link}>こちらから変更</a>
          </Link>
          ができます。
        </span>
      )}
    </div>
  );
  const ApplyButton = () =>
    !currentEntor ||
    (currentEntor?.interviewStatus !== InterviewStatus.Applied &&
      interviewValidYear(currentEntor?.user.lastGraduationYear || 0)) ? (
      <Link href={Routes.url("/interview/signup", {})}>
        <Button className={styles.button}>メンター面談を予約する</Button>
      </Link>
    ) : null;

  const defaultInterviewBanner = (
    <div className={classNames(styles.banner, className)}>
      <img src={interviewOnlineImage} width="100" alt="" />
      <div className={styles.content}>
        <div className={styles.textContent}>
          <div className={styles.title}>
            就活の不安を大学の先輩に相談しませんか？ <RecommendedBox />
          </div>
          {subTitle}
        </div>
        <ApplyButton />
      </div>
    </div>
  );

  const MobileInterviewBanner = (
    <div className={classNames(styles.mobileBanner, className)}>
      <div className={styles.topContent}>
        <img src={interviewOnlineImage} width="100" alt="" />
        <div className={styles.title}>
          就活の不安を大学の先輩に相談しませんか？{" "}
          <RecommendedBox className={styles.recommendBox} />
        </div>
        {subTitle}
      </div>
      <ApplyButton />
    </div>
  );

  return isMobile ? MobileInterviewBanner : defaultInterviewBanner;
};

export { InterviewBanner };
